import React from "react";
import { TextChoiceDefinition } from "../../../../types/Survey";
import TextChoiceList from "../../Components/TextChoiceList/TextChoiceList";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import useTranslate from "../../../../hooks/useTranslate";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let translations = useTranslate(["yes-label-text", "no-label-text"]);
    let currentResult = props.result as QuestionResultModel;

    let textChoices: TextChoiceDefinition[] = [
        { value: "True", text: translations["yes-label-text"] },
        { value: "False", text: translations["no-label-text"] }
    ];

    return <SurveyFormItem
        label={props.label}
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <TextChoiceList
            variant={props.variant}
            textChoices={textChoices}
            style="Single"
            selectedChoices={currentResult.Answer ? [currentResult.Answer] : []}
            onChangeChoices={(choices) => props.onResultChange({ ...props.result, Answer: choices.length > 0 ? choices[0] : "" } as QuestionResultModel)} />
    </SurveyFormItem>;
}